<!-- UploadFileAgentRenewLicense -->
<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
            col-12
            d-none d-lg-flex
            justify-content-between
            align-items-center
          ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            ขอต่ออายุใบอนุญาต
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          ps-3
          pe-3
        " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/AgenteService">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>
                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100 font-family blue-1">
                    ขอต่ออายุใบอนุญาต
                </div>
            </div>

            <div class="col">

                <StepBar :steps="['ตรวจสอบข้อมูล', 'อัปโหลดเอกสาร', 'ยืนยันการทำรายการ', 'ชำระเงิน', 'เสร็จสิ้น']"
                    :current="1" />

                <div class="title d-none d-lg-block border-bottom font-family blue-1">
                    ขอต่ออายุใบอนุญาต
                </div>

                <div class="container py-3 font-family-bla">
                    <div class="row g-4">
                        <!-- กล่อง 1: รูปถ่ายหน้าตรงใช้ติดบัตร -->
                        <div class="col-12 col-lg-6">
                            <div class="card-wrap p-3">
                                <h5 class="fw-bold mb-1">1. แนบไฟล์ : รูปถ่ายหน้าตรงใช้ติดบัตร<span
                                        class="text-danger">*</span></h5>
                                <p class="small text-muted mb-3">
                                    ข้อกำหนด : ไม่สวมแว่นกันแดด พื้นหลังไม่มีลวดลาย ไม่ยิ้มเห็นฟัน ไม่ใส่หมวก
                                    ไฟล์นามสกุล .JPG ขนาด 1 นิ้ว – 1.5 นิ้ว (300x300 DPI)
                                </p>

                                <!-- ยังไม่แนบ → โชว์โซนอัปโหลด -->
                                <div v-if="!files.photo" class="upload-zone" :class="{ 'is-dragover': dragOverA }"
                                    @dragover.prevent="dragOverA = true" @dragleave.prevent="dragOverA = false"
                                    @drop.prevent="addPhotoFile(Array.from($event.dataTransfer.files))">
                                    <input ref="fileA" type="file" accept=".jpg,.jpeg" class="d-none"
                                        @change="addPhotoFile(Array.from($event.target.files)); $event.target.value = '';">
                                    <p class="mb-2">ลากหรือวางไฟล์ของคุณที่นี่ หรือ <a href="#"
                                            @click.prevent="$refs.fileA.click()">เลือกไฟล์</a></p>
                                    <div class="small text-muted">รองรับ .JPG เท่านั้น</div>
                                </div>

                                <div v-else class="file-chip mt-3" style="position: relative; padding-right: 40px;">
                                    <div class="d-flex flex-column">
                                        <span class=" fw-bold">{{ files.photo.name }}</span>
                                        <small class="text-muted">{{ formatFileSize(files.photo.size) }}</small>
                                    </div>
                                    <font-awesome-icon :icon="faTrash"
                                        style="width:20px;height:20px;position:absolute;right:5px;top:50%;transform:translateY(-50%);cursor:pointer;color:red"
                                        @click="removePhoto()" />
                                </div>

                            </div>
                        </div>

                        <!-- กล่อง 2: วุฒิบัตร/หนังสือรับรองอบรม -->
                        <div class="col-12 col-lg-6">
                            <div class="card-wrap p-3">
                                <h5 class="fw-bold mb-1">2. แนบไฟล์ :
                                    หนังสือรับรองผ่านการอบรมหลักสูตรขอต่ออายุใบอนุญาตเป็นตัวแทนประกันชีวิต
                                    (วุฒิบัตร)<span class="text-danger">*</span>
                                </h5>
                                <p class="small text-muted mb-3">
                                    เพิ่มได้สูงสุด {{ this.manangeFiles.cert.LIMIT_AMOUNT_FILE }} ไฟล์
                                    ไฟล์นามสกุล .JPG/ .PDF ขนาดไฟล์รวมไม่เกิน
                                    {{ this.manangeFiles.cert.LIMIT_FILE_SIZE }}MB
                                </p>

                                <!-- Zone อัปโหลด -->
                                <div class="upload-zone" :class="{ 'is-dragover': dragOverB }"
                                    @dragover.prevent="dragOverB = true" @dragleave.prevent="dragOverB = false"
                                    @drop.prevent="addCertFiles(Array.from($event.dataTransfer.files))">
                                    <input ref="fileB" type="file" accept=".pdf,.jpg,.jpeg" class="d-none" multiple
                                        @change="addCertFiles(Array.from($event.target.files)); $event.target.value = '';">
                                    <p class="mb-2">
                                        ลากหรือวางไฟล์ของคุณที่นี่ หรือ
                                        <a href="#" @click.prevent="$refs.fileB.click()"
                                            :class="{ 'disabled': files.cert.length >= this.manangeFiles.cert.LIMIT_AMOUNT_FILE }">เลือกไฟล์</a>
                                    </p>
                                    <div class="small text-muted">รองรับ .PDF, .JPG (สูงสุด {{
                                        this.manangeFiles.cert.LIMIT_AMOUNT_FILE }} ไฟล์)</div>
                                </div>

                                <!-- รายการไฟล์วุฒิบัตร (มีสกอร์ลได้) -->
                                <div v-if="files.cert.length" class="mt-3">
                                    <div class="file-list-scroll">
                                        <div v-for="(file, index) in files.cert" :key="file.id || index"
                                            class="file-chip mb-2 d-flex justify-content-between align-items-center"
                                            style="position: relative; padding-right: 40px;">
                                            <div class="d-flex align-items-start gap-2">

                                                <div>
                                                    <span class="fw-bold">{{ file.name }}</span>
                                                    <template v-if="isServerFile(file)">
                                                        <small class="text-muted"> (ไฟล์ที่มีอยู่แล้ว)</small>
                                                    </template>
                                                    <br />
                                                    <small class="text-muted">{{ formatFileSize(file.size) }}</small>
                                                </div>
                                            </div>

                                            <font-awesome-icon :icon="faTrash"
                                                style="width:20px;height:20px;position:absolute;right:5px;top:50%;transform:translateY(-50%);cursor:pointer;color:red"
                                                @click="removeCert(index)" />
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>

                    </div>

                    <!-- ข้อความ Optional -->
                    <div class="mt-3" v-if="isRenewLicenseNo">
                        <label class="form-control-lg">
                            ท่านมีคุณสมบัติในการใช้สิทธิลดชั่วโมงอบรมเหลือ 15 ชั่วโมงตามที่ คปภ. กำหนด
                            และได้ดำเนินการยื่นเอกสารเพื่อขอใช้สิทธิลดหย่อนชั่วโมงอบรมที่ฝ่ายฝึกอบรมช่องทางการขายก่อนทำรายการนี้ล่วงหน้าอย่างน้อย
                            15 วัน เรียบร้อยแล้วหรือไม่?
                        </label>

                        <div class="form-check">
                            <input id="cbHas" class="form-check-input" type="checkbox" :checked="qualify.has"
                                @change="onCheck('has', $event.target.checked)">
                            <label for="cbHas" class="form-check-label">มีคุณวุฒิ และได้<label
                                    class="text-decoration-underline">ยื่นเอกสาร</label>เพื่อขอใช้สิทธิลดหย่อนชั่วโมงอบรมที่ฝ่ายฝึกอบรมช่องทางการขายล่วงหน้าเรียบร้อยแล้ว</label>
                        </div>

                        <div class="form-check">
                            <input id="cbNone" class="form-check-input" type="checkbox" :checked="qualify.none"
                                @change="onCheck('none', $event.target.checked)">
                            <label for="cbNone" class="form-check-label">ไม่มี คุณวุฒิ</label>
                        </div>
                    </div>

                    <div class="mt-2 text-danger">

                        <label class="form-control-lg">
                            <label class="text-decoration-underline">หมายเหตุ </label>
                            ในกรณีที่ท่านจองคอร์สอบรมหลักสูตรต่ออายุใบอนุญาตเป็นตัวแทนประกันชีวิต ผ่านระบบ
                            Bangkok Life Training
                            ระบบจะทำการดึงไฟล์หนังสือรับรองการอบรม (วุฒิบัตร) ให้อัตโนมัติได้เพียง 1 ครั้งเท่านั้น
                            กรุณาตรวจสอบความถูกต้องก่อนลบไฟล์ มิฉะนั้นท่านจะต้องดำเนินการอัปโหลดไฟล์หนังสือรับรองการอบรม
                            (วุฒิบัตร)
                            ด้วยตนเองอีกครั้ง
                        </label>
                    </div>

                    <!-- ปุ่ม -->
                    <div class="d-flex justify-content-center gap-3 mt-4">
                        <button class="btn btn-secondary btn-confirm" @click="goBack">ย้อนกลับ</button>
                        <button class="btn btn-bla btn-confirm" @click="next">ถัดไป</button>
                        <!-- ใส่ในปุ่ม ถัดไป :disabled="!canNext" -->
                    </div>

                </div>

            </div>
        </div>
    </div>

    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCircleXmark, faTrash } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

import StepBar from "./StepBar.vue";

import '@/styles/SweetAlert2CustomCSS.css';

export default {
    name: "UploadFileAgentRenewLicense",
    components: {
        Menu,
        FontAwesomeIcon,
        LoadingBs5,
        StepBar
    },
    data() {
        return {
            faCircleXmark: faCircleXmark,
            faTrash: faTrash,
            Loading: true,
            isRenewLicenseNo: false,// ใช่การต่ออายุคั้งที่ 4 หรือไม่?
            qualification: null,      // "has" หรือ "none"
            qualify: { has: false, none: false },  // เก็บสถานะ checkbox
            manangeFiles: {
                photo: {// รูปถ่ายหน้าตรงใช้ติดบัตร
                    LIMIT_AMOUNT_FILE: 1,// จำนวนไฟล์
                    LIMIT_FILE_SIZE: 4,// ขนาดไฟล์(mb)
                },
                cert: {// หนังสือรับรองผ่านการอบรมหลักสูตรขอต่ออายุใบอนุญาตเป็นตัวแทนประกันชีวิต (วุฒิบัตร)
                    LIMIT_AMOUNT_FILE: 15,// จำนวนไฟล์
                    LIMIT_FILE_SIZE: 10,// ขนาดไฟล์(mb)
                },
            },
            files: {
                photo: null,// รูปถ่ายหน้าตรงใช้ติดบัตร
                cert: []// หนังสือรับรองผ่านการอบรมหลักสูตรขอต่ออายุใบอนุญาตเป็นตัวแทนประกันชีวิต (วุฒิบัตร)
            },
            dragOverA: false,
            dragOverB: false,
            selectedCourse: '',
            courses: [],// หลักสูตร
            optionalChecked: false,
        };
    },
    computed: {
        canNext() {
            return !!this.files.photo && this.files.cert.length > 0
        },
        selectedQualification() {
            if (this.qualify.has) return 'has'
            if (this.qualify.none) return 'none'
            return null
        }
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();

        this.BindingData();
    },
    watch: {
        optionalChecked(val) {
            if (!val) this.selectedCourse = '';
        },
        isRenewLicenseNo(val) {
            if (!val) {
                this.optionalChecked = false;
                this.selectedCourse = '';
            }
        }
    },
    methods: {
        BindingData() {
            this.isRenewLicenseNo = (this.$store.state.AgentRenewLicense.preview.dataResp.requestAgentRenewLicenseNo >= 4);// ใช่การต่ออายุครั้งที่ 4 หรือไม่?

            this.loadExistingCertsAsFiles();   // ดึงของเก่าแล้ว “แปลงให้เป็น File”
        },
        // แปลง base64 → Uint8Array
        base64ToUint8Array(base64) {
            // รองรับกรณีมี prefix "data:...;base64,"
            const comma = base64.indexOf(',');
            const raw = comma >= 0 ? base64.slice(comma + 1) : base64;

            const binary = atob(raw);
            const len = binary.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
            return bytes;
        },
        // เดารูปแบบไฟล์จากชื่อ (ถ้า contentType ไม่ส่งมา)
        guessMimeFromName(name) {
            const ext = (name.split('.').pop() || '').toLowerCase();
            if (ext === 'pdf') return 'application/pdf';
            if (['jpg', 'jpeg'].includes(ext)) return 'image/jpeg';
            if (ext === 'png') return 'image/png';
            return 'application/octet-stream';
        },
        // ฟังก์ชันใหม่: รับรูปแบบ API → สร้าง File object
        apiEntryToFile(entry) {
            const fileName = entry.fileName ?? entry.FileName;
            const contentType = entry.contentType ?? entry.ContentType;
            const fileData = entry.fileData ?? entry.FileData;

            if (!fileName || !fileData) throw new Error('missing file fields');

            const bytes = Array.isArray(fileData) ? new Uint8Array(fileData) : this.base64ToUint8Array(fileData);
            const type = contentType || this.guessMimeFromName(fileName);
            return new File([bytes], fileName, { type, lastModified: Date.now() });
        },
        // MOCK: ดึงไฟล์วุฒิบัตรเดิมจาก API แล้ว “แปลงเป็น File[]”
        async loadExistingCertsAsFiles() {

            // 1) สมมติข้อมูลจาก API (คุณแทนที่ด้วยผลจริงได้)
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/LoadImageIdCertificationExists", { headers: { Authorization: `Bearer ${AuthorizeToken}` } })
                .then(async (response) => {
                    if (response.status == 200) {
                        if (response.data.length > 0) {
                            // 2) แปลงทั้งหมดเป็น File objects
                            const fileList = await Promise.all(response.data.map(this.apiEntryToFile));

                            // 3) ใส่ลงกอง cert (ตอนนี้เป็น File[] จริง)
                            this.files.cert = fileList;
                        }
                    }
                }).catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                    }).then(() => {
                        localStorage.removeItem("Token");
                        localStorage.removeItem("AuthorizeToken");
                        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                    });
                });
        },
        // ทำให้ checkbox เลือกได้ทีละอัน
        onCheck(which, checked) {
            if (which === 'has') {
                this.qualify.has = checked;
                this.qualify.none = false;// exclusive
                this.qualification = checked ? 'has' : null;
            } else if (which === 'none') {
                this.qualify.none = checked;
                this.qualify.has = false;// exclusive
                this.qualification = checked ? 'none' : null;
            }
        },
        goBack() {
            this.$store.state.AgentRenewLicense.uploadfile.files.photo = null;
            this.$store.state.AgentRenewLicense.uploadfile.files.certs = [];
            this.$store.state.AgentRenewLicense.uploadfile.opt = false;
            this.$store.state.AgentRenewLicense.uploadfile.course = '';
            this.$store.state.AgentRenewLicense.uploadfile.qualification = null;

            //Tc7Certification อ่านคำร้องคุณสมบัติ
            this.$router?.replace?.('/Tc7Certification');
        },
        async next() {
            const canProceed = await this.Authentication('L01');
            if (!canProceed) {
                return; // หยุดการทำงานถ้ามีเอกสารอยู่แล้ว
            }

            const sizeLimitMb = this.manangeFiles.cert.LIMIT_FILE_SIZE;

            // --- ตรวจขั้นต่ำก่อน (ถ้าต้องการแจ้งเตือน) ---
            if (!this.files.photo) {
                return Swal.fire({
                    icon: 'error',
                    html: `<label class="fs-4 fw-normal font-family">กรุณาแนบไฟล์รูปถ่ายหน้าตรงใช้ติดบัตรแนบได้ 1 ไฟล์ ขนาดไม่เกิน 4MB</label>`,
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla'// pv-btn-primary
                    }
                });
            }
            if (!this.files.cert?.length) {
                return Swal.fire({
                    icon: 'error',
                    html: `<label class="fs-4 fw-normal font-family">กรุณาแนบไฟล์หนังสือรับรองผ่านการอบรมหลักสูตรขอต่ออายุใบอนุญาตเป็นตัวแทนประกันชีวิต (วุฒิบัตร)</label>`,
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla'// pv-btn-primary
                    }
                });
            }

            const totalBytes = this.totalSize(this.files.cert);
            if (totalBytes > this.mbToBytes(sizeLimitMb)) {
                return this.swalErr(`ขนาดไฟล์รวมต้องไม่เกิน ${sizeLimitMb} MB (ปัจจุบัน ${this.formatFileSize(totalBytes)})`);
            }

            if (this.isRenewLicenseNo && !this.qualification) {
                await Swal.fire({
                    icon: 'warning',
                    // title: 'กรุณาเลือกคุณวุฒิ',
                    html: '<label class="fs-5 fw-normal font-family-bla">กรุณาตอบคำถามให้ครบถ้วนก่อนกดถัดไป</label>',
                    // confirmButtonText: 'ตกลง',
                    allowOutsideClick: false,
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla'// pv-btn-primary
                    }
                });
                return;
            }

            this.Loading = true;
            try {
                // Call Api ตรวจสอบ Script ภายในไฟล์
                await this.scanPdfScriptFiles(this.files.photo, this.files.cert);

                this.Loading = false;

                this.$store.state.AgentRenewLicense.uploadfile.files.photo = this.files.photo;
                this.$store.state.AgentRenewLicense.uploadfile.files.certs = this.files.cert;
                this.$store.state.AgentRenewLicense.uploadfile.opt = this.optionalChecked;
                this.$store.state.AgentRenewLicense.uploadfile.course = (this.isRenewLicenseNo && this.optionalChecked) ? this.selectedCourse : null;
                this.$store.state.AgentRenewLicense.uploadfile.qualification = this.qualification;

                this.$router?.replace?.('/ReviewDraftAgentRenewLicense');// ตรวจสอบความถูกต้องของแบบร่างคำรับรองคุณสมบัติ ตช.7 และแบบฟอร์มต่อทะเบียนตัวแทน Unit Linked

            } catch (err) {
                this.Loading = false;
                // ถ้าไม่ผ่านหรือ error
                Swal.fire({
                    icon: 'error',
                    html: `<label class="fs-4 fw-normal font-family">อัปโหลดไฟล์ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง</label>`,
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla'
                    }
                });
                return;
            }
        },
        async scanPdfScriptFiles(photoFile, certFiles) {
            const AuthorizeToken = localStorage.getItem('AuthorizeToken');

            const formData = new FormData();
            formData.append("Photo", photoFile);// รูปถ่ายหน้าตรงใช้ติดบัตร
            // หนังสือรับรองผ่านการอบรมหลักสูตรขอต่ออายุใบอนุญาตเป็นตัวแทนประกันชีวิต (วุฒิบัตร)
            for (let cert of certFiles) {
                formData.append("Certs", cert); // key ต้องตรงกับ property
            }

            const response = await fetch(
                process.env.VUE_APP_URL_API + "AgencyERequest/ScanPdfScriptFiles", {
                method: "POST",
                headers: { Authorization: `Bearer ${AuthorizeToken}` },
                body: formData
            });

            // ถ้า API ไม่มี script จะได้ 204 หรือ 2xx =>
            if (response.status === 204 || (response.ok && response.status >= 200 && response.status < 300)) {
                return; // ปลอดภัย ไม่ต้องทำอะไร
            }

            // ถ้ามี script / error
            let message = "ตรวจพบ script หรือไฟล์ไม่ปลอดภัย กรุณาตรวจสอบไฟล์";
            try {
                const data = await response.json();
                if (data?.ErrorMessage) message = data.ErrorMessage;
            } catch (e) {
                // เผื่อ body ไม่ใช่ json
            }

            throw new Error(message);
        },
        // ---------- Helpers ----------
        isServerFile(item) { return !!item.isServer; },
        isPdf(item) { return (item.type || item.mime || '').includes('pdf') || /\.pdf$/i.test(item.name); },
        isImage(item) { return (item.type || item.mime || '').startsWith('image/') || /\.(jpg|jpeg|png)$/i.test(item.name); },

        mbToBytes(mb) { return mb * 1024 * 1024; },
        totalSize(files) { return files.reduce((s, f) => s + f.size, 0); },
        formatFileSize(size) {
            if (!size && size !== 0) return '';
            if (size < 1024) return size + ' B'
            if (size < 1024 * 1024) return Math.round(size / 1024) + ' KB'
            return (size / (1024 * 1024)).toFixed(2) + ' MB'
        },
        swalErr(msg) {
            Swal.fire({
                icon: 'error',
                html: `<label class="fs-5 fw-normal font-family-bla">${msg}</label>`,
                customClass: {
                    popup: 'swal-wide',
                    confirmButton: 'btn-bla'// pv-btn-primary
                }
            })
        },
        // ---------- ข้อ 1: รูปถ่าย (ไฟล์เดียว .JPG ≤ XXX MB) ----------
        addPhotoFile(list) {
            this.dragOverA = false;
            const add = Array.from(list || []);
            if (!add.length) return;

            const amtLimit = this.manangeFiles.photo.LIMIT_AMOUNT_FILE;   // จำนวนไฟล์สูงสุด
            const sizeLimitMb = this.manangeFiles.photo.LIMIT_FILE_SIZE;  // ขนาดไฟล์สูงสุด (MB)

            // จำนวนไฟล์ (ควบคุมด้วย config)
            if (add.length > amtLimit) {
                return this.swalErr(`อัปโหลดได้สูงสุด ${amtLimit} ไฟล์`);
            }

            const f = add[0]; // เนื่องจาก photo ปกติ 1 ไฟล์
            if (!f) return;

            if (f.size > this.mbToBytes(sizeLimitMb)) {
                return this.swalErr(`ขนาดไฟล์ต้องไม่เกิน ${sizeLimitMb} MB`);
            }

            const ext = f.name.split('.').pop().toLowerCase();
            if (!['jpg', 'jpeg'].includes(ext)) {
                return this.swalErr('รองรับไฟล์นามสกุล .JPG เท่านั้น');
            }

            // ถ้า config อนุญาตมากกว่า 1 ไฟล์
            if (amtLimit > 1) {
                this.files.photo = [...(this.files.photo || []), ...add];
            } else {
                this.files.photo = f; // ปกติคือไฟล์เดียว
            }
        },
        removePhoto() {
            this.files.photo = null
        },
        // ---------- ข้อ 2: วุฒิบัตร (หลายไฟล์ .PDF/.JPG รวม ≤ 10MB, สูงสุด 15 ไฟล์) ----------
        addCertFiles(list) {
            this.dragOverB = false;
            const add = Array.from(list || []);
            if (!add.length) return;

            const amtLimit = this.manangeFiles.cert.LIMIT_AMOUNT_FILE;
            const sizeLimitMb = this.manangeFiles.cert.LIMIT_FILE_SIZE;

            // นามสกุล
            for (const f of add) {
                const ext = f.name.split('.').pop().toLowerCase();
                if (!['pdf', 'jpg', 'jpeg'].includes(ext))
                    return this.swalErr('รองรับไฟล์ .PDF หรือ .JPG เท่านั้น');
            }

            // จำนวนไฟล์ (เดิม + ใหม่)
            if (this.files.cert.length + add.length > amtLimit) {
                return this.swalErr(`อัปโหลดได้สูงสุด ${amtLimit} ไฟล์`);
            }

            // ขนาดรวม (เดิม + ใหม่)
            const combined = [...this.files.cert, ...add];
            const totalBytes = this.totalSize(combined);
            if (totalBytes > this.mbToBytes(sizeLimitMb)) {
                return this.swalErr(`ขนาดไฟล์รวมต้องไม่เกิน ${sizeLimitMb} MB (ปัจจุบัน ${this.formatFileSize(totalBytes)})`);
            }

            this.files.cert = combined;
        },
        removeCert(index) {
            this.files.cert.splice(index, 1);
        },
        async Authentication(SUBJOB) {
            try {
                const AuthorizeToken = localStorage.getItem("AuthorizeToken");
                const request = {
                    AGENTCODE: [],
                    SUBJOB: SUBJOB
                };

                const res = await http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } });

                if (res.data === '001' || res.data === '002') {
                    Swal.fire({
                        icon: 'error',
                        html: '<label class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</label>',
                    }).then(() => {
                        this.$router.replace('/AgenteService');
                    });
                    return false; // มีเอกสารอยู่แล้ว
                }

                console.log('ยังไม่มีเอกสารที่สร้างไปก่อนหน้า');
                return true; // สามารถดำเนินการต่อได้

            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดของระบบ</label>',
                }).then(() => {
                    this.$router.replace("/AgenteService");
                });
                return false; // ไม่สามารถดำเนินการต่อได้
            }
        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
    },
};
</script>

<style scoped>
/* ปุ่ม: เต็มความกว้างบนมือถือ และกว้างพอดีบนจอใหญ่ */
.btn-confirm {
    width: 100%;
}

@media (min-width: 768px) {
    .btn-confirm {
        width: 25%;
        min-width: 160px;
        max-width: 320px;
    }
}

/* ฟอนต์และธีม */
.font-family-bla {
    font-family: "DB Heavent", sans-serif;
}

.file-list-scroll {
    max-height: 250px;
    /* ปรับความสูงที่ต้องการ */
    overflow-y: auto;
    /* เปิด scrollbar แนวตั้ง */
    border: 1px solid #eee;
    border-radius: 6px;
    padding: 8px;
    background: #fafafa;
}

/* กล่อง */
.card-wrap {
    border: 2px solid #A2B9E2;
    border-radius: 12px;
    background: #fff;
}

/* โซนอัปโหลด */
.upload-zone {
    border: 2px dashed #A2B9E2;
    border-radius: 10px;
    padding: 18px;
    text-align: center;
    background: #f8fbff;
    transition: .2s;
}

.upload-zone.is-dragover {
    background: #eaf3ff;
    border-color: #6da8ff;
}

/* ชิปไฟล์ */
.file-chip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #d1e3ff;
    background: #e7f1ff;
    border-radius: 10px;
    padding: .5rem .75rem;
}

.truncate {
    max-width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ปุ่ม */
.btn-pill {
    border-radius: 999px;
    padding: .6rem 1.6rem;
    min-width: 140px;
}

.swal2-popup .btn-bla {
    background-color: #004c9c;
    color: #fff;
}
</style>